import * as React from 'react';
//import * as Select from 'react-select';
import { BaseComponent } from './BaseComponent';
import { ChiamaAPI, Trad } from './';
import { Link, NavLink } from 'react-router-dom';
import * as Dati from '../Dati';

export class TabellaLista extends BaseComponent<Dati.ITabellaListaProps, {}> {

    public static defaultProps: Partial<Dati.ITabellaListaProps> = {
        Dati: undefined,
        Funzione1: undefined,
        Funzione2: undefined,
        Funzione3: undefined,
        Sort: undefined
    };

    public render() {
        return <div className={this.props.CSS} id={this.props.Id}>
            <table className="kt-datatable__table">
                <thead className="kt-datatable__head">
                    {this.props.PopolaColonne(this.props.Dati, this.props.Sort)}
                </thead>
                <tbody className="kt-datatable__body" style={{}}>{this.props.PopolaRighe(this.props.Dati, this.props.Funzione1, this.props.Funzione2, this.props.Funzione3)}</tbody>
            </table>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/TabellaLista.tsx